import * as yup from 'yup';
import { email, password } from './baseSchema';

const LoginSchema = yup.object().shape({
  email,
  password,
});

export default LoginSchema;
